import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-uploader',
  templateUrl: './uploader.component.html',
  styleUrls: ['./uploader.component.scss'],
})
export class UploaderComponent {
  @Input() title?: string;
  @Input() label1?: string;
  @Input() label2?: string;
  @Input() buttonLabel?: string;
  @Output() filesChanged: EventEmitter<File[]> = new EventEmitter<File[]>();
  onFilesChanged(files: File[]) {
    this.filesChanged.emit(files);
  }
}
